import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { ListQuote } from "../../types/Quote";

type SetQuoteVisibilityPayload = {
  dossierId: string;
  quoteId: string;
  visibility: boolean;
};

export const setQuoteVisibility = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    optimisiticUpdateOnMutate,
    getDataByQueryKey,
  } = useAPQuery();

  return useMutation({
    mutationFn: (payload: SetQuoteVisibilityPayload): Promise<boolean> => {
      return fetchWithAuth<boolean>("setQuoteVisibility", payload.quoteId, {
        requestOptions: { method: "post", body: JSON.stringify(payload) },
      });
    },
    onMutate: async (payload) => {
      const queryKey = ["quotes", payload.dossierId];
      const quotes = getDataByQueryKey(queryKey) as ListQuote[];
      const quoteIndex = quotes.findIndex(
        (quote) => quote.identifiers.crmQuoteId === payload.quoteId
      );
      const quoteToUpdate = quotes[quoteIndex];
      const updatedQuotes = [...quotes];
      updatedQuotes[quoteIndex] = {
        ...quoteToUpdate,
        config: {
          ...quoteToUpdate.config,
          isVisible: payload.visibility,
        },
      };

      optimisiticUpdateOnMutate(queryKey, updatedQuotes);
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
